// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightCircleOutlinedSvg from "@fishx/icons-svg/es/asn/RightCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var RightCircleOutlined = function RightCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleOutlinedSvg
  }));
};

RightCircleOutlined.displayName = 'RightCircleOutlined';
export default React.forwardRef(RightCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RightCircleOutlined.js
// module id = 4011
// module chunks = 0